import _createClass from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { wrapperGet, wrapperPost } from '@/utils/http';
export default new ( /*#__PURE__*/_createClass(function ShoppingCartApi() {
  _classCallCheck(this, ShoppingCartApi);

  _defineProperty(this, "cartList", wrapperGet('/api/client-ubq-app/cart/list'));

  _defineProperty(this, "cartAdd", wrapperPost('/api/client-ubq-app/cart/add'));

  _defineProperty(this, "cartRemove", wrapperPost('/api/client-ubq-app/cart/remove'));

  _defineProperty(this, "cartCount", wrapperGet('/api/client-ubq-app/cart/count'));
}))();